<div class="tw-flex tw-grow v2-wrapper">
	<!-- BEGIN ALL SCREEN SIZE DISPLAY -->
	<div class="passes-wrapper teacher-view" (scroll)="homePageService.scroll($event)" [style.overflow]="'auto'" *ngIf="homePageService.effectiveUser">
		<div #passesContainer class="main-page-left teacher-view">
			<!-- PASS BUTTONS -->
			<div class="pass-buttons" *ngIf="screenService.windowWidth <= 544">
				<app-create-pass-button
					[title]="'Schedule Pass'"
					[disabled]="emergencyService.isEmergencyActivated.value"
					[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : ''"
					(onClick)="homePageService.showMainForm(true)"></app-create-pass-button>
				<app-create-pass-button
					cdkOverlayOrigin
					#overlayTrigger="cdkOverlayOrigin"
					[title]="'Create Pass'"
					[backgroundColor]="'#00B476'"
					[hoverBackgroundColor]="'#009964'"
					[icon]="'add-icon.svg'"
					[textColor]="'#fff'"
					[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : homePageService.createButtonTooltipText"
					(mouseenter)="homePageService.showStudentNoFlyTimeTooltip()"
					(mouseleave)="homePageService.closeStudentNoFlyTimeTooltip()"
					[disabled]="emergencyService.isEmergencyActivated.value"
					(onClick)="homePageService.showMainForm(false)">
				</app-create-pass-button>
				<ng-template
					cdkConnectedOverlay
					[cdkConnectedOverlayOrigin]="overlayTrigger"
					[cdkConnectedOverlayOpen]="homePageService.isOpenStudentNoFlyTimeTooltip | async"
					[cdkConnectedOverlayWidth]="189"
					[cdkConnectedOverlayHeight]="89"
					[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
				</ng-template>
			</div>
			<!-- END PASS BUTTONS -->

			<div class="heading">
				<div class="date-time-header">
					<div class="tw-flex">
						<div class="date-time">
							<sp-date [date]="date$ | async"></sp-date>

							<ng-container *ngIf="dayTypeDisplay$ | async as dayType">
								<sp-day-type
									*ngIf="dayType.hasMultipleScheduleGroups"
									cdkOverlayOrigin
									#scheduleOverlayTrigger="cdkOverlayOrigin"
									[dayType]="dayType.longDayName == 'Other' ? 'Modified Day' : dayType.longDayName"
									(mouseover)="homePageService.dayTypeTooltipOpen.next(true)">
									<ng-container *ngIf="scheduleService.countdownData$ | async as countdownData">
										<!-- SCHEDULES TOOLTIP FOR DAY TYPE -->
										<ng-template
											cdkConnectedOverlay
											[cdkConnectedOverlayOpen]="homePageService.dayTypeTooltipOpen | async"
											[cdkConnectedOverlayHeight]="scheduleService.scheduleTooltipHeight$ | async"
											[cdkConnectedOverlayOrigin]="scheduleOverlayTrigger"
											[cdkConnectedOverlayOffsetY]="-32"
											[cdkConnectedOverlayPositions]="[{ originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' }]">
											<ng-container
												[ngTemplateOutlet]="schedulesTooltipTemplate"
												[ngTemplateOutletContext]="{ countdownData: countdownData }"></ng-container>
										</ng-template>
										<!-- SCHEDULES TOOLTIP -->
									</ng-container>
								</sp-day-type>
							</ng-container>
							<sp-no-fly-time
								*ngIf="homePageService.noFlyTimeNuxAndTooltip$ | async as noFlyTimeNuxAndTooltip"
								[isActive]="homePageService.noFlyTimeActive"
								[until]="homePageService.currentNoFlyEndTimeString"
								[noFlyTimeTooltipHeight]="homePageService.noFlyTimeTooltipHeight"
								[noFlyTimeTooltipPosition]="homePageService.noFlyTimeTooltipPosition"
								[hasActivePassRequest]="homePageService.hasActivePassRequest"
								[noFlyTimes]="noFlyTimeNuxAndTooltip.noFlyTimes"
								[currentNoFlyTimeIndex]="homePageService.currentNoFlyTimeIndex"></sp-no-fly-time>
						</div>
					</div>

					<div class="tw-flex tw-justify-between">
						<div *ngIf="scheduleService.countdownData$ | async as countdownData; else noSchedulesGreeting">
							<!-- PERIOD COUNT DOWN AND GREETING FOR SCHEDULES -->
							<sp-period-countdown
								(mouseover)="homePageService.periodCountDownTooltipOpen.next(true)"
								cdkOverlayOrigin
								#scheduleOverlayTrigger2="cdkOverlayOrigin"
								[countdownData]="countdownData"></sp-period-countdown>

							<sp-greeting
								[greeting]="homePageService.greeting$ | async"
								*ngIf="!countdownData.hasPeriodTimes || countdownData.beforeSchool || countdownData.schoolOver"></sp-greeting>
							<!-- END PERIOD COUNT DOWN AND GREETING FOR SCHEDULES -->

							<!-- SCHEDULES TOOLTIP FOR PERIOD COUNTDOWN -->
							<ng-template
								cdkConnectedOverlay
								[cdkConnectedOverlayOpen]="homePageService.periodCountDownTooltipOpen | async"
								[cdkConnectedOverlayHeight]="scheduleService.scheduleTooltipHeight$ | async"
								[cdkConnectedOverlayOrigin]="scheduleOverlayTrigger2"
								[cdkConnectedOverlayOffsetY]="-35">
								<ng-container
									[ngTemplateOutlet]="schedulesTooltipTemplate"
									[ngTemplateOutletContext]="{ countdownData: countdownData }"></ng-container>
							</ng-template>
							<!-- SCHEDULES TOOLTIP -->
						</div>

						<ng-template #noSchedulesGreeting>
							<sp-greeting [greeting]="homePageService.greeting$ | async"></sp-greeting>
						</ng-template>

						<!-- edit here -->
						<!-- CURRENTLY IN ROOM -->
						<ng-container *ngIf="roomSwitchService.teacherRooms">
							<app-currently-in
								[roomOptions]="roomSwitchService.teacherRooms"
								[selectedLocation]="roomSwitchService.selectedRoom$ | async"
								[showEndedPasses]="homePageService.showEndedPasses.value"
								(selectedLocationEmit)="roomSwitchService.userSwitchedRooms($event)"
								(kioskModeEmit)="homePageService.setRoomToKioskMode($event)"
								(roomCodeEmit)="homePageService.openRoomCodeDialog($event)"
								(showEndedPassesEmit)="homePageService.toggleShowEndedPasses($event)">
							</app-currently-in>
							<!-- END CURRENTLY IN ROOM -->
						</ng-container>
					</div>
				</div>

				<div class="line-break"></div>

				<ng-template #hasRooms>
					<ng-container
						*ngIf="
							((homePageService._teacherHasPasses | async) === false && (waitingInLinePasses?.length ?? 0) === 0 && hasSchedules) ||
								((waitingInLinePasses?.length ?? 0) > 0 === false && (homePageService.activePasses2?.length ?? 0) > 0 === false && !hasSchedules) ||
								((homePageService.activePasses2?.length ?? 0) > 0 === false && wilUIRefresh);
							else hasPasses
						">
						<div class="no-passes">
							<p class="text">Student Going Somewhere?</p>
							<app-create-pass-button
								cdkOverlayOrigin
								#secondOverlayTrigger="cdkOverlayOrigin"
								[title]="'Create Pass'"
								[backgroundColor]="'#00B476'"
								[hoverBackgroundColor]="'#009964'"
								[icon]="'add-icon.svg'"
								[textColor]="'#fff'"
								[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : homePageService.createButtonTooltipText"
								(mouseenter)="homePageService.showSecondStudentNoFlyTimeTooltip()"
								(mouseleave)="homePageService.closeSecondStudentNoFlyTimeTooltip()"
								[disabled]="
									emergencyService.isEmergencyActivated.value || (homePageService.isActivePass$ | async) || homePageService.hasActivePassRequest
								"
								(onClick)="homePageService.showMainForm(false)">
							</app-create-pass-button>
						</div>
					</ng-container>

					<ng-template #hasPasses>
						<div class="pass-collection">
							<sp-pass-collection-v2>
								<app-pass-tile
									collection-content
									*ngFor="let pass of homePageService.activePasses2"
									[pass]="pass"
									[isActive]="true"
									[profileImage]="true"
									[forStaff]="true"
									[allowPopup]="true"
									(tileSelected)="homePageService.openPassDialog(pass, true, false)"
									(endPass)="homePageService.endPass(pass)">
								</app-pass-tile>
							</sp-pass-collection-v2>
						</div>

						<div *ngIf="!wilUIRefresh" class="pass-collection">
							<sp-pass-collection-v2>
								<app-pass-tile
									collection-content
									*ngFor="let pass of homePageService.waitInLinePasses | async"
									[pass]="pass"
									[waitInLine]="true"
									[profileImage]="true"
									[forStaff]="true"
									[allowPopup]="true"
									(tileSelected)="homePageService.openPassDialog(pass, true, false)">
								</app-pass-tile>
							</sp-pass-collection-v2>
						</div>
					</ng-template>

					<ng-container *ngIf="scheduleService.countdownData$ | async as countdownData">
						<!-- weekend -->
						<div class="no-classes" *ngIf="countdownData.isWeekend">
							<span><img class="tw-w-5 tw-mr-1" [src]="'./assets/weekend.png'" alt="" /> Enjoy your weekend!</span>
						</div>

						<!-- modified schedule -->
						<ng-container
							*ngIf="
								!countdownData.isWeekend &&
								(countdownData.schoolOver || countdownData.beforeSchool) &&
								(scheduleService.myScheduleForToday$ | async) as todaysSchedule
							">
							<div class="no-classes" *ngIf="todaysSchedule?.modified">
								<span><img class="tw-w-5 tw-mr-1" [src]="'./assets/holiday.png'" alt="" /> {{ todaysSchedule.schedule_groups[0].day_name }}</span>
							</div>
						</ng-container>

						<!-- holiday -->
						<ng-container *ngIf="!countdownData.isWeekend && (scheduleService.mySchedulesAgendaForToday$ | async) as agenda">
							<div class="no-classes" *ngIf="agenda?.no_school_day">
								<span
									><img *ngIf="agenda.no_school_day" class="tw-w-5 tw-mr-1" [src]="'./assets/holiday.png'" alt="" /> {{ agenda.no_school_day }}</span
								>
							</div>
						</ng-container>
					</ng-container>
					<!-------------- end  period countdown -------------->

					<!-------------- new wait inline -------------->
					<div class="class-info" *ngIf="waitingInLinePasses?.length > 0 && wilUIRefresh">
						<sp-collapsible-card [collapsible]="false">
							<div sp-collapsible-card-header class="coming-this-period-header">
								<span> Waiting in Line </span>
								<sp-wil-help-icon [roomPassLimit]="passLimits[currentRoom?.id]" [isBlocking]="wilBlocked$ | async"></sp-wil-help-icon>
							</div>
							<div collapsible-card-content style="width: 100%">
								<div class="student-list tw-pt-8">
									<sp-student-list-item
										*ngFor="let pass of waitingInLinePasses; let i = index"
										[student]="pass.student"
										[ordered]="pass.is_origin_line"
										[groups]="studentGroupMap.get(pass.student.id) || []"
										[index]="i"
										[backgroundColor]="hoveredId === pass.id ? '#F5F6F8' : '#ffffff'"
										(hovered)="hoveredId = $event ? pass.id : null"
										class="student-item">
										<div sp-student-list-item-right class="student-item-right-side wil-buttons">
											<app-create-pass-button
												*ngIf="hoveredId === pass.id && !pass.isReadyToStart()"
												[width]="'101px'"
												[height]="'31px'"
												[fontSize]="'12px'"
												[fontWeight]="'400'"
												[iconMarginRight]="'4px'"
												[title]="'Skip the Line'"
												[backgroundColor]="'#FFFFFF'"
												[hoverBackgroundColor]="'#FFFFFF'"
												[icon]="'start.svg'"
												[textColor]="'#7083A0'"
												(onClick)="homePageService.startWILPass(pass, true)"
												(mousedown)="$event.stopPropagation()">
											</app-create-pass-button>
											<sp-student-pass-info
												[pass]="pass"
												[passType]="'wait_in_line'"
												class="student-pass-info"
												(click)="homePageService.onPassInfoClick(pass)"
												(mousedown)="$event.stopPropagation()">
											</sp-student-pass-info>
										</div>
									</sp-student-list-item>
								</div>
							</div>
						</sp-collapsible-card>
					</div>
					<!-------------- end new wait inline -------------->

					<!-------------- upcoming passes template -------------->
					<ng-container *ngIf="upcomingPasses$ | async as passes">
						<div class="class-info" *ngIf="passes.length">
							<sp-collapsible-card [collapsible]="false">
								<div sp-collapsible-card-header class="coming-this-period-header">
									<span> {{ upcomingPassHeader }} </span>
								</div>
								<div collapsible-card-content style="width: 100%">
									<div class="student-list" style="padding-top: 32px">
										<sp-student-list-item
											*ngFor="let pass of passes"
											[student]="pass.student"
											[groups]="studentGroupMap.get(pass.student.id) || []"
											[style.background-color]="'#FFFFFF'"
											class="student-item">
											<div sp-student-list-item-right class="student-item-right-side">
												<sp-student-pass-info
													[pass]="pass"
													[passType]="'active'"
													class="student-pass-info"
													(click)="homePageService.openPassDialog(pass, true, false)"
													(mousedown)="$event.stopPropagation()">
												</sp-student-pass-info>
											</div>
										</sp-student-list-item>
									</div>
								</div>
							</sp-collapsible-card>
						</div>
					</ng-container>
					<!-------------- end upcoming passes template -------------->

					<!-------------- agenda items -------------->
					<ng-container *ngIf="agendaItems$ | async as agendaItems">
						<ng-container *ngFor="let agendaItem of agendaItems">
							<ng-container *ngIf="agendaItem.item.type === 'class'">
								<ng-template [ngTemplateOutlet]="classAgendaItems" [ngTemplateOutletContext]="{ agendaItem: agendaItem }"></ng-template>
							</ng-container>
							<ng-container *ngIf="agendaItem.item.type === 'activity'">
								<sp-teacher-home-activity [agendaItem]="agendaItem" [clickRight]="onClickActivity"></sp-teacher-home-activity>
							</ng-container>
						</ng-container>

						<!-------------- class template -------------->
						<ng-template #classAgendaItems let-agendaItem="agendaItem">
							<div class="classes-container">
								<div class="class-info">
									<ng-container
										[ngTemplateOutlet]="classRow"
										[ngTemplateOutletContext]="{
											count: agendaItem.passes.size,
											agendaItem: agendaItem
										}"></ng-container>
								</div>
							</div>
						</ng-template>
						<!-------------- end class template -------------->
					</ng-container>
					<!-------------- end agenda items -------------->

					<!-------------- ended passes -------------->
					<div class="past-passes pass-collection" *ngIf="homePageService.showEndedPasses | async">
						<sp-pass-collection-v2>
							<sp-collection-title>Ended Passes</sp-collection-title>
							<sp-collection-header-action>
								<div class="filter-icon" style="cursor: pointer" (click)="homePageService.openFilter($event, PassFilterModel.PastPasses)">
									<img style="width: 24px; height: 24px" [src]="'./assets/New Filter.svg' | resolveAsset" alt="Filter Icon" />
								</div>
							</sp-collection-header-action>
							<app-pass-tile
								collection-content
								*ngFor="let pass of homePageService.pastPasses2"
								(tileSelected)="homePageService.openPassDialog(pass, true, false)"
								[fromPast]="true"
								[forStaff]="true"
								[pass]="pass"
								[allowPopup]="true"
								[profileImage]="!!homePageService.effectiveUser.show_profile_pictures"
								[isEnableProfilePictures]="!!homePageService.effectiveUser.show_profile_pictures"></app-pass-tile>

							<sp-collection-empty-state *ngIf="homePageService.pastPasses2?.length === 0">
								<span class="tw-text-navy-500 dark:tw-text-white tw-font-medium tw-text-[18px]">No Passes ended yet!</span>
							</sp-collection-empty-state>
						</sp-pass-collection-v2>
					</div>
					<!-------------- end ended passes -------------->
				</ng-template>

				<!-------------- not assigned to any rooms -------------->
				<ng-container *ngIf="!roomSwitchService.teacherRooms?.length; else hasRooms">
					<div class="teacher-unassigned-rooms">
						<div class="icon-container">
							<img [src]="'./assets/armchair.svg'" alt="armchair icon" />
						</div>
						<div class="text">
							<p class="header">You are not assigned to any rooms.</p>
							<p class="subtitle" style="font-weight: 400 !important">Reach out to your admin if this is a mistake.</p>
						</div>
						<app-white-button
							[rightIcon]="'./assets/External Link (Blue-Gray).svg'"
							[rightIconWidth]="'15px'"
							[width]="'280px'"
							[height]="'50px'"
							[routerLink]="'/main/hallmonitor'">
							<span>Go to Hall Monitor</span>
						</app-white-button>
					</div>
				</ng-container>
				<!-------------- end not assigned to any rooms -------------->
			</div>

			<sp-pass-requests-sidebar
				[isStaff]="true"
				[nowRequests]="homePageService.nowRequests"
				[scheduledRequests]="homePageService.scheduledRequests"
				[activeTabIndex]="homePageService.activeTabIndex"
				[sortIconData]="homePageService.sortIconData"
				[_showRequestTitles]="homePageService._showRequestTitles"
				[emptyPassRequestMessage]="homePageService.emptyPassRequestMessage"
				[isStudent]="false"
				[toggleSortPreference]="homePageService.toggleAndSaveSortPreference.bind(homePageService)"
				[updateEmptyMessage]="homePageService.getEmptyPassRequestMessage.bind(homePageService)"
				[passesLoaded]="homePageService.passesLoaded"
				(openPassDialog)="homePageService.openPassDialogFromSidebar($event)">
			</sp-pass-requests-sidebar>
		</div>
	</div>
	<ng-template #studentList let-students="students" let-passes="passes">
		<sp-student-list-item
			*ngFor="let student of students"
			[student]="student.user ? student.user : student"
			[user]="effectiveUser"
			[groups]="studentGroupMap.get(student.user ? student.user.id : student.id) || []"
			(hovered)="hoveredId = $event ? (student.user ? student.user.id : student.id) : null"
			class="student-item">
			<div sp-student-list-item-right class="student-item-right-side">
				<app-create-pass-button
					*ngIf="hoveredId !== null && hoveredId === (student.user ? student.user.id : student.id)"
					[width]="'101px'"
					[height]="'31px'"
					[fontSize]="'12px'"
					[fontWeight]="'400'"
					[iconMarginRight]="'4px'"
					[title]="'Create Pass'"
					[backgroundColor]="'#00B476'"
					[hoverBackgroundColor]="'#009964'"
					[style.padding-right]="homePageService.studentPassesMap.get(student.user ? student.user.id : student.id)?.length ? '0px' : '8px'"
					[icon]="'add-icon.svg'"
					[textColor]="'#fff'"
					[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : homePageService.createButtonTooltipText"
					[disabled]="emergencyService.isEmergencyActivated.value || (homePageService.isActivePass$ | async) || homePageService.hasActivePassRequest"
					(onClick)="homePageService.showMainFormForStudent(false, student.user ? student.user : student, this.currentRoom)"
					(mousedown)="$event.stopPropagation()">
				</app-create-pass-button>
				<ng-container
					*ngIf="passes.get(student.user ? student.user.id : student.id) as pass"
					[ngTemplateOutlet]="passInfo"
					[ngTemplateOutletContext]="{
						pass: pass
					}"></ng-container>
			</div>
		</sp-student-list-item>
	</ng-template>

	<ng-template #passInfo let-pass="pass">
		<sp-student-pass-info
			[pass]="pass"
			[passType]="'active'"
			class="student-pass-info"
			(click)="homePageService.openPassDialog(pass, true, false)"
			(mousedown)="$event.stopPropagation()">
		</sp-student-pass-info>
	</ng-template>

	<ng-template #classRow let-count="count" let-agendaItem="agendaItem">
		<sp-collapsible-card
			[collapsible]="true"
			[collapsedBubbleText]="count === 0 ? '' : count === 1 ? count + ' Upcoming Pass' : count + ' Upcoming Passes'"
			[collapsed]="agendaItem.item.data.class.collapsed || agendaItem?.collapsed"
			(titleRightContainerClicked)="onClickClass(agendaItem?.item.data.class?.id, agendaItem.collapsed)">
			<div sp-collapsible-card-header class="class-info-header class-info-header-hover" (click)="openClassDetailsModal(agendaItem.item.data.class)">
				<span> {{ agendaItem.item.data.class.display_name }} </span>
				<img src="./assets/Twinkie (Blue-Gray).svg" alt="right-icon" [style.width]="'16px'" [style.height]="'16px'" />
			</div>

			<div collapsible-card-content style="width: 100%">
				<div class="search">
					<app-round-input
						data-cy="search-inp-students"
						[width]="'100%'"
						[backgroundColor]="'#FFFFFF'"
						[color]="'#1F195E'"
						[fontSize]="'18px'"
						[height]="'32px'"
						[borderRadius]="'8px'"
						[noFocus]="true"
						[boxShadow]="false"
						(ontextupdate)="onStudentSearch($event, agendaItem.item.data.class)"
						(blurEvent)="isSearchingStudents = {}"
						[placeholder]="'Search students'"
						#studentSearchInput="roundInputRef"
						#inputComponent>
					</app-round-input>
				</div>
				<div class="student-list">
					<div
						class="no-students-found"
						*ngIf="isSearchingStudents[agendaItem.item.data.class.id] && studentSearchResults[agendaItem.item.data.class.id].length === 0">
						<span class="main-text"> No students found </span>
					</div>

					<ng-container
						*ngIf="isSearchingStudents[agendaItem.item.data.class.id]"
						[ngTemplateOutlet]="studentList"
						[ngTemplateOutletContext]="{ students: studentSearchResults[agendaItem.item.data.class.id], passes: agendaItem.passes }"></ng-container>

					<ng-container
						*ngIf="!isSearchingStudents[agendaItem.item.data.class.id]"
						[ngTemplateOutlet]="studentList"
						[ngTemplateOutletContext]="{ students: agendaItem.item.data.class.class_users.students, passes: agendaItem.passes }"></ng-container>
				</div>
			</div>
		</sp-collapsible-card>
	</ng-template>

	<ng-template #schedulesTooltipTemplate let-countdownData="countdownData">
		<div (mouseleave)="closeTooltips()" style="padding-top: 35px">
			<app-schedule-tooltip
				*ngIf="true"
				[@TooltipFadeInOut]="'visible'"
				[scheduleGroups]="scheduleService.scheduleGroups$ | async"
				[isRotating]="countdownData.isRotating"
				[multipleDayTypes]="countdownData.multipleDayTypes"
				[selectedTabIndex]="(scheduleService.scheduleGroupIndex$ | async)?.index || 0"
				[periodTimes]="scheduleService.periodTimes$ | async"
				[currentPeriod]="countdownData.currentPeriod"
				[nextPeriod]="countdownData.nextPeriod"
				[noActivePeriod]="!countdownData.currentPeriod"
				[dayType]="
					(scheduleService.scheduleGroup$ | async)?.long_day_name == 'Other'
						? 'Modified Day'
						: (scheduleService.scheduleGroup$ | async)?.long_day_name
				"
				[isAdmin]="isAdmin"
				(scheduleGroupChanged)="scheduleService.scheduleGroupIndex$.next($event)">
			</app-schedule-tooltip>
		</div>
	</ng-template>
</div>

<!--templates for class details tabbed modal-->
<ng-template #classDetailsStudentList>
	<div class="tw-w-full tw-h-full tw-bg-white">
		<sp-class-student-list
			*ngIf="classDetailsData"
			[userCanEditClass]="userCanEditClass"
			[accountType]="classDetailsData.classDetails.external_source_name"
			[students]="classDetailsData.classStudents || []"
			[initiateAddStudent]="classDetailsData.initiateAddStudent"
			[autoSetFocusOnSearch]="classDetailsData.autoSetFocusOnSearch"
			[dialogSecondaryBtnLbl]="classDetailsData.dialogSecondaryBtnLbl"
			[syncData]="syncData$"
			(closeModal)="closeClassDetailsModal()"></sp-class-student-list>
	</div>
</ng-template>

<ng-template #classDetails>
	<sp-class-details [data]="classDetailsData"></sp-class-details>
</ng-template>
